import React from 'react';
import { useParams } from 'react-router-dom';
import { Header } from '../Common';
import BulkProduct from '../../Common/BulkProduct';
import { getBulkProduct } from './bulkProductData';
import { SIZE_GUIDE_TITLE, SIZE_GUIDE_ITEMS } from '../Product/sizeGuideData';

/**
 * CLS-FI BulkProduct — thin brand wrapper.
 * Layout + logic live in `Clothing/Common/BulkProduct`.
 */
const CLSFIBulkProduct = () => {
  const { slug } = useParams();
  const product = getBulkProduct(slug);

  return (
    <BulkProduct
      product={product}
      brand="CLS"
      cartBrandSlug="clsfi"
      priceSuffix=" €"
      Header={Header}
      labels={{
        sizeTitle: 'Valitse koko',
        sizeGuide: 'Kokotaulukko',
        infoTemplate: (n) => `Tilaa vähintään ${n} kpl tätä tuotetta.`,
        buttonLabel: 'Lisää ostoskoriin',
        minError: (n) => `Vähintään ${n} kpl yhteensä`,
        notFound: 'Tuotetta ei löytynyt.',
        riskFree: {
          title: 'OSTA RISKITTÖMÄSTI',
          description: '24 TUNTIA AIKAA MUOKATA TAI PERUUTTAA TILAUKSESI',
        },
        delivery: {
          time: '3 viikkoa',
          cost: 'Ilmainen',
          description: 'Toimitus kouluusi',
        },
      }}
      sizeGuide={{ title: SIZE_GUIDE_TITLE, items: SIZE_GUIDE_ITEMS }}
    />
  );
};

export default CLSFIBulkProduct;
